import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Icon } from "@/components/Icon";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="dark flex min-h-screen items-center justify-center bg-background">
      <div className="text-center space-y-6">
        <div className="mx-auto w-20 h-20 rounded-2xl bg-surface-container flex items-center justify-center">
          <Icon name="explore_off" size="xl" className="text-on-surface-variant/50" />
        </div>
        <div>
          <h1 className="text-6xl font-headline font-black text-foreground tracking-tighter mb-2">404</h1>
          <p className="text-lg text-on-surface-variant">Signal lost. This route does not exist.</p>
        </div>
        <a
          href="/"
          className="inline-flex items-center gap-2 bg-primary text-white px-6 py-3 rounded-full font-headline font-bold text-sm uppercase tracking-wider hover:opacity-90 transition-opacity"
        >
          <Icon name="home" size="sm" />
          Return to Observatory
        </a>
      </div>
    </div>
  );
};

export default NotFound;
